var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('Bar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"styles":{ height: '300px' }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }